import React, { useEffect, useState } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Tooltip,
  IconButton,
  Input
} from "@material-ui/core";
import { Remove, Add, Clear } from "@material-ui/icons";

const OptionalTooltip = ({ title, hideTooltip, children }) => {
  if (hideTooltip) {
    return children;
  }
  return <Tooltip title={title}>{children}</Tooltip>;
};

const AudioOffsetInput = ({
  onAudioOffsetChanged,
  defaultAudioOffset,
  disabled = false,
  disabledTooltip = "Audio offset adjustment is not available."
}) => {
  const [audioOffsetValue, setAudioOffsetValue] = useState(defaultAudioOffset);
  const [disableButtons, setDisableButtons] = useState(false);

  const buttonDisabled = disabled || disableButtons;

  useEffect(() => {
    // The only scenario where this useEffect needs to run is when a feed is switched
    // or somehow the value in the store falls out of sync with the value here.
    if (defaultAudioOffset !== parseFloat(audioOffsetValue)) {
      updateAudioOffset(defaultAudioOffset);
    }
  }, [defaultAudioOffset]);

  useEffect(() => {
    if (!disabled) {
      return;
    }

    resetAudioOffset();
  }, [disabled]);

  const updateAudioOffset = value => {
    if (!/^-?\d*\.?\d*$/.test(value)) {
      return;
    }

    setAudioOffsetValue(value);

    if (!isNaN(value)) {
      onAudioOffsetChanged(value);
      setDisableButtons(false);
    } else {
      setDisableButtons(true);
      onAudioOffsetChanged("0");
    }
  };

  const stepAudioOffset = step => {
    const float = audioOffsetValue === "" ? 0.0 : parseFloat(audioOffsetValue);

    if (!isNaN(float)) {
      const offset = (float + step).toFixed(1);
      setAudioOffsetValue(offset);
      onAudioOffsetChanged(offset);
    }
  };

  const resetAudioOffset = () => {
    setAudioOffsetValue("0");
    onAudioOffsetChanged("0");
  };

  return (
    <Grid item>
      <OptionalTooltip title={disabledTooltip} hideTooltip={!disabled}>
        <FormControl style={{ textAlign: "center" }}>
          <InputLabel
            shrink
            style={{
              whiteSpace: "nowrap",
              textAlign: "center"
            }}
            id="audio-track-offset"
          >
            {"Audio Offset (s)"}
          </InputLabel>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{
              marginTop: 16
            }}
          >
            <OptionalTooltip
              title="Delay Audio Track: audio track is ahead of video"
              hideTooltip={disabled}
            >
              <IconButton
                onClick={() => stepAudioOffset(-0.1)}
                size="small"
                disabled={buttonDisabled}
              >
                <Remove style={{ fontSize: "1rem" }} />
              </IconButton>
            </OptionalTooltip>
            <Input
              type="text"
              label="Audio Offset"
              id="audio-track-offset-input"
              value={audioOffsetValue}
              error={isNaN(audioOffsetValue)}
              style={{
                width: "40px",
                padding: 0
              }}
              disabled={disabled}
              onChange={event => {
                const value = event.target.value;
                updateAudioOffset(value);
              }}
            />
            <OptionalTooltip
              title="Advance Audio Track: audio track is behind video"
              hideTooltip={disabled}
            >
              <IconButton
                onClick={() => stepAudioOffset(0.1)}
                size="small"
                disabled={buttonDisabled}
              >
                <Add style={{ fontSize: "1rem" }} />
              </IconButton>
            </OptionalTooltip>
            <OptionalTooltip title="Reset audio offset" hideTooltip={disabled}>
              <IconButton
                onClick={() => resetAudioOffset()}
                size="small"
                disabled={disabled}
                style={{
                  marginLeft: 6
                }}
              >
                <Clear style={{ fontSize: "1rem" }} />
              </IconButton>
            </OptionalTooltip>
          </Grid>
        </FormControl>
      </OptionalTooltip>
    </Grid>
  );
};

export default AudioOffsetInput;



// WEBPACK FOOTER //
// ./src/components/AudioOffsetInput.js